import { NotificationsIFrame } from "components/organisms/NotificationsIFrame";

const NotificationsList = () => {
  return <NotificationsIFrame page="list" />;
};

export { NotificationsList };
